<template>
  <div class="bg_base">
    <div class="temp_wave">
      <img
        src="../../assets/img/V.1 020921 Journey Background Wave Comp0.png"
        width="100%"
        alt=""
      />
    </div>
    <div class="temp_result">
      <div class="pb-3"></div>
      <section class="logo d-flex justify-center">
        <img src="../../assets/img/logo-teman-bakat.png" height="90px" alt="" />
      </section>
      <section class="logo d-flex justify-center">
        <img
          src="../../assets/img/ineed/Report-Misi-WorkValue-Banner0.png"
          height="90px"
          alt=""
        />
      </section>
      <div class="relative-center" v-if="result">
        <div class="temp-item">
          <div class="item-0">
            <strong class="white--text">{{ result[0].singkatan }}</strong>
          </div>
          <div class="item-1">
            <strong class="white--text">{{ result[1].singkatan }}</strong>
          </div>
          <div class="item-2">
            <strong class="white--text">{{ result[2].singkatan }}</strong>
          </div>
          <div class="item-3">
            <strong class="white--text">{{ result[3].singkatan }}</strong>
          </div>
          <div class="item-4">
            <strong class="white--text">{{ result[4].singkatan }}</strong>
          </div>
        </div>
      </div>
      <section class="mb-2 d-flex justify-center">
        <img
          src="../../assets/img/ineed/Report-Misi-WorkValue20.png"
          height="250px"
          alt=""
        />
      </section>
      <section class="pa-3">
        <p class="purple--text">
          <strong>Deskripsi :</strong>
        </p>
        <v-card v-for="(item, idx) in result" :key="idx" class="pa-3 mb-2">
          <section class="d-flex align-center">
            <v-icon small class="mr-1">mdi-check-circle</v-icon>
            <strong>{{ item.tipe }}</strong>
          </section>
          <section class="d-flex">
            <div class="mr-4"></div>
            {{ item.deskripsi }}
          </section>
        </v-card>
      </section>
    </div>
    <uiDownload />
  </div>
</template>

<script>
import uiDownload from "../downloadScheme/uiDownload.vue";
export default {
  components: { uiDownload },
  name: "resultIam",
  data() {
    return {
      result: "",
      pyramid: {},
    };
  },
  mounted() {
    let data = JSON.parse(localStorage.getItem("testujuankerja"));
    this.result = JSON.parse(data.result);
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.bg_base {
  position: relative;
  background: url("../../assets/img/Misi1-3-2Report Background.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
}
.logo {
  margin-bottom: 30px;
}
.relative-center {
  position: relative;
  display: flex;
  justify-content: center;
}
.temp-item {
  /* margin-top: 30px; */
  position: absolute;
  width: 250px;
  height: 250px;
  /* background: chartreuse; */
  /* opacity: 0.5; */
  z-index: 2;
}
.item-0 {
  /* position: absolute; */
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
.item-1 {
  position: absolute;
  margin-left: 32px;
  margin-top: 30px;
}
.item-2 {
  position: absolute;
  margin-left: 195px;
  margin-top: 30px;
}
.item-3 {
  position: absolute;
  margin-left: 62px;
  margin-top: 128px;
}
.item-4 {
  position: absolute;
  margin-left: 166px;
  margin-top: 128px;
}
.temp_wave {
  top: 0;
  position: absolute;
}
.temp_result {
  position: relative;
  z-index: 2;
}
</style>
